
// src/connects/division-groups-page.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import actions from '../actions'
import { trackPage } from '../helpers/analytics'
import socketRsync, { requireSocketEmit } from '../helpers/socket-rsync'
import context, { inject } from '../helpers/context'
import find from 'lodash/find'
import { isSmartPhone } from '../helpers/agent-type'
import {getArray} from "../helpers/store";
import {replaceRoute} from "../actions/route";

export const mapStateToProps = (state, ownProps)=> {
  const diaries = state.diaries.groups.home
  const division = getArray('division_id', state.divisions.items, state.divisions.currentId) || undefined

  return {
    user: state.user.current,
    isFetching: diaries && diaries.isFetching,
    isFetchFailed: diaries && diaries.isFetchFailed,
    hasMore: diaries && diaries.hasMore,
    diaries: diaries && diaries.items,
    isRightSidebar: (state.rightSidePage.name || ownProps.children) && true,
    isPhone: state.media.isPhone,
    rightSidePage: state.rightSidePage,
    likeConfig: state.likes.likeConfig,
    binding: true,
    currentDivisionId: state.divisions.currentId,
    divisionSettings: state.divisionSettings,
    division: division
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    fetchDiaries: dispatchProps.fetchDiaries.bind(stateProps)
  })
}


export const mapDispatchToProps = (dispatch, ownProps)=> {
  function _readDiary(props, diary) {
    const read = diary.user.user_id == props.user.user_id || diary.readers && find(diary.readers, (reader)=> reader.user.user_id == props.user.user_id)
    if (!read) {
      !props.emitSocket('mark_as_read', { diary_id: diary.diary_id }) && dispatch(actions.markDiaryRead(diary.diary_id))
    }
  }

  return {
    fetchDiaries: function(props, reset = false) {
      if (this && this.binding) props = this
      if (props.isFetching || props.isFetchFailed && !reset) return
      var offset = reset ? 0 : props.diaries && props.diaries.length || 0
      dispatch(actions.fetchHomeDiaries(offset, props.currentDivisionId))
    },

    openSearchDrawer: (props)=> dispatch(actions.openRightSidePage('search_drawer', { group_id: 'home' })),
    clearDiaries: ()=> dispatch(actions.clearDiaries('home')),
    closeRightSidePage: ()=> dispatch(actions.closeRightSidePage(true)),

    readDiary: _readDiary,
    _readDiary: _readDiary,

    willMount: (props)=> {
      const { division_id } = props.params
      dispatch(actions.fetchHomeNotificationsUnreadCount(division_id))
      dispatch(actions.fetchHomeDiaries(0, division_id))
      if (props.params && props.params.division_id)
        dispatch(actions.setCurrentDivisionId(props.params.division_id))
    },

    willUnmount: ()=> {
      dispatch(actions.closeRightSidePage(true))
      dispatch(actions.clearPreservedQueries())
    },
    willUpdate: (props, nextProps)=> {
      if (props.division && !nextProps.division) {
        replaceRoute('main')
      }
      if (props.params.division_id != nextProps.params.division_id) {
        dispatch(actions.closeRightSidePage(true))
        const { division_id } = nextProps.params
        dispatch(actions.fetchHomeNotificationsUnreadCount(division_id))
        dispatch(actions.fetchHomeDiaries(0, division_id))
        dispatch(actions.setCurrentDivisionId(nextProps.params.division_id))
      }
    },

    receiveSocket: (message, message_type, props)=> {
      switch(message_type) {
      case 'diary':
        dispatch(actions.loadDiary(
          Object.assign({}, message.diary, { group: message.group }), {
            appending: message.appending,
            own_post: message.diary.user.user_id == props.user.user_id,
            group_id: 'home',
          }))
        break
      case 'diary_delete':
        dispatch(actions.loadDiary(message.diary, { deleted: true, group_id: 'home' }))
        break
      case 'notification':
        dispatch(actions.loadHomeNotificationUnreadCount(message.home_count))
        break
      }
    },

    requestSync: (props)=> {
      const { division_id } = props.params
      dispatch(actions.fetchHomeNotificationsUnreadCount(division_id))
      dispatch(actions.fetchHomeDiaries(0, division_id))
    },
    // webでsearch-drawerを開くために必要
    editSearchDrawer: (props)=> props.updateUI({ openDrawer: true }),
    closeDivisionSettingsPage: ()=> dispatch(actions.closeDivisionSettingsPage()),
  }
}

export default combineHOC(
  requireSocketEmit,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  socketRsync('notification', 'diary', 'diary_delete'),
  ui({ state: { active: false, openDrawer: false }}),
  lifecycle,
  translate(),
  inject({ _readDiary: PropTypes.func, editSearchDrawer: PropTypes.func }),
  trackPage('division_timeline'),
)



// WEBPACK FOOTER //
// ./src/connects/division-groups-page.js